import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getSelectedCookies, getManagerDependingVariables } from ".";
import { getOtherOptionsFromWindow } from "../../utils";
import { OPT_IN_EVENT } from "../../types";
import { putHtmlCodeToDom } from "@devowl-wp/headless-content-unblocker";
/**
 * Opt-in to a set of cookies.
 */

function applyOptIn(_x) {
  return _applyOptIn.apply(this, arguments);
}

function _applyOptIn() {
  _applyOptIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(type) {
    var allOptInCookies, _getSelectedCookies, isManagerActive, iterateCookies, _getOtherOptionsFromW, setCookiesViaManager, _getManagerDependingV, useGlobalObjectName, useVariableNamePascal, isManagerOptOut, dataLayerPromise, waitPromises;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            allOptInCookies = [];
            _getSelectedCookies = getSelectedCookies(type), isManagerActive = _getSelectedCookies.isManagerActive, iterateCookies = _getSelectedCookies.iterateCookies;
            _getOtherOptionsFromW = getOtherOptionsFromWindow(), setCookiesViaManager = _getOtherOptionsFromW.setCookiesViaManager;
            _getManagerDependingV = getManagerDependingVariables(isManagerActive, setCookiesViaManager), useGlobalObjectName = _getManagerDependingV.useGlobalObjectName, useVariableNamePascal = _getManagerDependingV.useVariableNamePascal; // Handle managers like GTM and MTM

            isManagerOptOut = false;
            dataLayerPromise = Promise.resolve(undefined);
            waitPromises = []; // Handle opt-ins sequentially

            _context2.next = 9;
            return iterateCookies( /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(group, cookie, isOptIn) {
                var presetId, codeDynamics, codeOptIn, rest, isManager, isOnlyWhenNoConsentToManager, restrictOptInCodeForPreset;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        presetId = cookie.presetId, codeDynamics = cookie.codeDynamics, codeOptIn = cookie.codeOptIn, rest = _objectWithoutProperties(cookie, ["presetId", "codeDynamics", "codeOptIn"]);
                        isManager = isManagerActive && rest["thisIs".concat(useVariableNamePascal)];

                        if (isOptIn) {
                          // Check if the script should explicitly only be loaded if no consent is given to the manager
                          isOnlyWhenNoConsentToManager = isManagerActive && rest["codeOptInNo".concat(useVariableNamePascal)];
                          restrictOptInCodeForPreset = ["amazon-associates-widget"].indexOf(presetId) > -1;

                          if (!isOnlyWhenNoConsentToManager && !restrictOptInCodeForPreset) {
                            waitPromises.push(putHtmlCodeToDom(codeOptIn, codeDynamics));
                          } // If this is a manager, wait for the object to be loaded

                          /* Silence is golden... Until you have PRO Version! */


                          // If this is a manager, wait for the object to be loaded

                          /* Silence is golden... Until you have PRO Version! */
                          document.dispatchEvent(new CustomEvent(OPT_IN_EVENT, {
                            detail: {
                              group: group,
                              cookie: cookie
                            }
                          }));
                          allOptInCookies.push({
                            group: group,
                            cookie: cookie
                          });
                        } else if (isManager) {
                          /* Silence is golden... Until you have PRO Version! */
                        }

                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x2, _x3, _x4) {
                return _ref.apply(this, arguments);
              };
            }());

          case 9:
            return _context2.abrupt("return", {
              isManagerOptOut: isManagerOptOut,
              dataLayerPromise: dataLayerPromise,
              cookies: allOptInCookies,
              ready: Promise.all(waitPromises)
            });

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _applyOptIn.apply(this, arguments);
}

export { applyOptIn };